import { render } from "./Explore.vue?vue&type=template&id=000837bc"
import script from "./Explore.vue?vue&type=script&lang=ts"
export * from "./Explore.vue?vue&type=script&lang=ts"
script.render = render

export default script